<template>
  <div v-if="showBar" class="actions_bar">
    <v-btn
      v-if="canReassignDriver"
      color="warning"
      depressed
      @click="$emit('assign-driver')"
    >
      <i class="fal fa-exchange-alt mr-1"></i>
      {{ $t("BUTTONS.reassign_driver") }}
    </v-btn>

    <template v-if="isBundleFinished">
      <v-btn color="success" depressed @click="$emit('view-invoice')">
        <i class="fal fa-file-alt mr-1"></i>
        {{ $t("BUTTONS.view_invoice") }}
      </v-btn>
      <v-btn outlined color="primary" @click="$emit('download-invoice')">
        <i class="fal fa-download mr-1"></i>
        {{ $t("BUTTONS.download_invoice") }}
      </v-btn>
    </template>
  </div>
</template>

<script>
export default {
  name: "BundleActionsBar",

  props: {
    canReassignDriver: {
      type: Boolean,
      default: false,
    },
    isBundleFinished: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    showBar() {
      return this.canReassignDriver || this.isBundleFinished;
    },
  },
};
</script>
